import { FaChevronDown } from "react-icons/fa";

export default function ScrollDownIndicator() {
  return (
    <div className="flex flex-col items-center mt-8 animate-bounce text-ocean">
      <span className="text-base font-semibold mb-1">
        Scroll down to learn more
      </span>
      <FaChevronDown className="text-2xl" />
    </div>
  );
}
